import { render } from "./ContactView.vue?vue&type=template&id=31dbcd2a&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=31dbcd2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dbcd2a"]])

export default __exports__